export enum NotificationListPosition {
    TopLeft = 'top-left',
    TopRight = 'top-right',
    BottomRight = 'bottom-right',
    BottomLeft = 'bottom-left'
}

export enum NotificationListItemLayout {
    Left = 'left',
    Right = 'right',
    Top = 'top',
    Bottom = 'bottom'
}

export enum NotificationListItemType {
    Success = 'success',
    Alert = 'alert',
    Warning = 'warning',
    Info = 'info'
}

export enum NotificationListItemAppearance {
    Light = 'light',
    Dark = 'dark',
    Glass = 'glass'
}
